import React, { useState, useEffect } from "react";
import Select from "react-select";
import { IoCloseOutline } from "react-icons/io5";
import { AiOutlineDelete } from "react-icons/ai";
import { FiFilter } from "react-icons/fi";
import { FcRefresh } from "react-icons/fc";
import { BsDownload } from "react-icons/bs";
import { BiCommentError } from "react-icons/bi";
import { RiFilePaperLine } from "react-icons/ri";
import { FiEdit } from "react-icons/fi";
import DashLayout from "../../layouts/DashLayout";
import Table from "../../components/Table";
import Overlay from "../../components/Overlay";
import Action from "../../components/Action";
import { beneficiaryStatus } from "../../utils/DataSource";
import { getBeneficiries } from "../../store/actions/BenActions";
import { useParams } from "react-router";
import { Link, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { changeFromTimeStamp } from "../../utils/changeFromTimeStamp";
import {
  addVisitAttendee,
  deleteVisitAttendee,
  getVisitAttendees,
  updateVisitAttendee,
} from "../../store/actions/VisitAttendeeActions";
import {
  deleteVisit,
  getVisitById,
  updateVisit,
} from "../../store/actions/VisitActions";
import { style, color } from "../../styles/Style";
import { ToastContainer } from "react-toastify";
import ContentLoader from "react-content-loader";

function ViewVisit() {
  const dispatch = useDispatch();

  const beneficiaries = useSelector((state) => state.beneficiries);
  const visitedBens = useSelector((state) => state.visitAttendeesState);
  const visitEvent = useSelector((state) => state.visitState.visit);
  const loaders = useSelector((state) => state.loadersState);

  const [event, setEvent] = useState({
    id: "",
    name: "",
    startDate: "",
    endDate: "",
  });
  const [visitedBen, setVisitedBen] = useState({
    id: "",
    beneficiaryId: "",
    visitedOn: "",
    visitedAt: "Home",
    visitor: "",
    comment: "",
  });
  const [openUpperTab, setOpenUpperTab] = useState(1);
  const [addBenOverlay, setAddBeneOverlay] = useState(0);
  function benOverlayController() {
    setAddBeneOverlay(!addBenOverlay);
  }

  const [filterBenOverlay, setFilterBeneOverlay] = useState(0);
  function filterOverlayController() {
    setFilterBeneOverlay(!filterBenOverlay);
  }
  const [editBenOverlay, setEditBeneOverlay] = useState(0);
  function editOverlayController(passedAttendee) {
    setEditBeneOverlay(!editBenOverlay);
    setVisitedBen({
      id: passedAttendee.id,
      beneficiaryId: passedAttendee.visitedBeneficiary.id,
      visitedAt: passedAttendee.visitedAt,
      visitedOn: changeFromTimeStamp(passedAttendee.visitedOn),
      visitor: passedAttendee.visitor,
      comment: passedAttendee.visitingComment,
    });
  }

  const [editVisit, setEditVisit] = useState(0);
  function editVisitController(passedEvent) {
    setEditVisit(!editVisit);
    setEvent({
      id: passedEvent.id,
      name: passedEvent.name,
      startDate: changeFromTimeStamp(passedEvent.startDate),
      endDate: changeFromTimeStamp(passedEvent.endDate),
    });
  }
  const [addVisit, setAddVisit] = useState(0);
  function AddVisitController() {
    setAddVisit(!addVisit);
  }
  const [filterVisitOverlay, setFilterVisitOverlay] = useState(0);
  function VisitFilterOverlayController() {
    setFilterVisitOverlay(!filterVisitOverlay);
  }

  // for insurance table
  const columns = React.useMemo(
    () => [
      {
        Header: "#",
        accessor: "count",
      },
      {
        Header: "Beneficiary",
        accessor: "beneficiary",
      },
      {
        Header: "VisitedAt",
        accessor: "visitDate",
      },
      // {
      //   Header: "Visitor",
      //   accessor: "visitor",
      // },
      {
        Header: "Comment",
        accessor: "comment",
      },
      {
        Header: "Action",
        accessor: "action",
      },
    ],
    []
  );

  // transform visitedBens data
  let [loadedAttendees, setLoadedAttendees] = useState([]);
  useEffect(() => {
    for (let i = 0; i < visitedBens.length; i++) {
      const visitedBen = {
        count: i + 1,
        id: visitedBens[i].id,
        beneficiary: `${visitedBens[i].visitedBeneficiary.firstName}  ${visitedBens[i].visitedBeneficiary.lastName}`,
        visitDate: changeFromTimeStamp(visitedBens[i].visitedOn),
        testSite: visitedBens[i].visitedAt,
        comment: visitedBens[i].visitingComment,
        action: (
          <Action
            editAction={() => {
              editOverlayController(visitedBens[i]);
            }}
            deleteAction={() => {
              handleDelete(visitedBens[i].id);
            }}
            benId={visitedBens[i].id}
          />
        ),
      };

      setLoadedAttendees((loadedAttendees) => [...loadedAttendees, visitedBen]);

      if (
        loaders.benVisit.deletingAction &&
        loaders.benVisit.deletingAction.deleting
      ) {
        const currentAttendees = loadedAttendees;
        const newData = currentAttendees.map((ourAttendee) =>
          ourAttendee.id === loaders.benVisit.deletingAction.id
            ? {
                ...ourAttendee,
                action: (
                  <div className="spinner red-spinner m-auto">
                    <div className="bounce1"></div>
                    <div className="bounce2"></div>
                    <div className="bounce3"></div>
                  </div>
                ),
              }
            : ourAttendee
        );
        setLoadedAttendees(newData);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visitedBens, loaders.benVisit.deletingAction]);

  let [loadingAttendees, setLoadingAttendees] = useState([]);

  useEffect(() => {
    setLoadingAttendees([]);
    for (let i = 0; i < 5; i++) {
      const visitedBen = {
        count: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),
        beneficiary: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),
        visitDate: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),
        testSite: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),
        comment: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),
        action: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),
      };
      setLoadingAttendees((loadingAttendees) => [
        ...loadingAttendees,
        visitedBen,
      ]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loaders.benVisit.fetchingLoaders]);

  const { eventid } = useParams();
  const selectedVisit = eventid;
  let history = useHistory();

  // handle delete
  const handleDeleteEvent = (id) => {
    dispatch(deleteVisit(id, redirectAfterDelete));
  };

  function redirectAfterDelete() {
    history.push("/services/events");
  }
  useEffect(() => {
    dispatch(getVisitById(selectedVisit));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    dispatch(getBeneficiries());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    dispatch(getVisitAttendees());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // handle delete
  const handleDelete = (id) => {
    dispatch(deleteVisitAttendee(id));
  };
  // beneficiries select option
  const beneficiriesOption = [];
  for (let i = 0; i < beneficiaries.length; i++) {
    const beneficiary = {
      value: beneficiaries[i].id,
      label: beneficiaries[i].beneficiaryCode,
      name: beneficiaries[i].firstName + " " + beneficiaries[i].lastName,
    };

    beneficiriesOption.push(beneficiary);
  }

  const selectedBeneficiary = beneficiriesOption.filter(
    (beneficiary) => beneficiary.value === visitedBen.beneficiaryId
  );
  // handle member submit
  const handleAttendeeSubmit = (e) => {
    e.preventDefault();
    if (visitedBen.id) {
      const id = visitedBen.id;
      const updatedAttendee = {
        id: visitedBen.id,
        visitedBeneficiaryId: {
          idValue: visitedBen.beneficiaryId,
        },
        visitId: {
          idValue: selectedVisit,
        },
        visitedOn: visitedBen.visitedOn,
        visitedAt: visitedBen.visitedAt,
        visitingComment: visitedBen.comment,
      };

      dispatch(
        updateVisitAttendee(updatedAttendee, id, closeAttendeeAfterUpdating)
      );
    } else {
      const newAttendee = {
        ...visitedBen,
        visitedBeneficiaryId: {
          idValue: visitedBen.beneficiaryId,
        },
        visitId: {
          idValue: selectedVisit,
        },
        visitedOn: visitedBen.visitedOn,
        visitedAt: visitedBen.visitedAt,
        visitingComment: visitedBen.comment,
      };
      dispatch(addVisitAttendee(newAttendee, closeAttendeeFormAfterAdding));
    }
  };
  // handle event  submit
  const handleVisitSubmit = (e) => {
    e.preventDefault();
    const id = event.id;
    const visit = {
      id: event.id,
      endDate: event.endDate,
      name: event.name,
      startDate: event.startDate,
    };
    dispatch(updateVisit(visit, id, closeVisitAfterUpdating));
  };

  // closing product after cu
  function closeAttendeeFormAfterAdding() {
    benOverlayController();
    setVisitedBen({
      id: "",
      beneficiaryId: "",
      visitedOn: "",
      visitedAt: "Home",
      visitor: "",
      comment: "",
    });
  }

  function closeAttendeeAfterUpdating() {
    editOverlayController({
      id: "",
      beneficiaryId: "",
      visitedOn: "",
      visitedAt: "Home",
      visitor: "",
      comment: "",
    });
  }
  // closing product after u

  function closeVisitAfterUpdating() {
    editVisitController({
      id: "",
      name: "",
      startDate: "",
      endDate: "",
    });
  }
  return (
    <DashLayout>
      <div className="text-xs">
        <ToastContainer />
      </div>
      {(!loaders.visit.loadingOne && !visitEvent.id) |
      loaders.visit.loadingOneFailedMsg ? (
        <div
          className={
            !loaders.visit.loadingOneFailedMsg
              ? "bg-white mx-10 h-60 flex  text-xs rounded text-center py-2 px-4 text-gray-500 font-semibold"
              : "bg-red-100 mx-10 h-60 flex text-xs rounded  text-center py-2 px-4 text-red-500 font-semibold"
          }
        >
          <div className="m-auto">
            {!loaders.visit.loadingOneFailedMsg ? (
              <div className="flex-col">
                <RiFilePaperLine className="text-3xl mx-auto my-3" />{" "}
                <p>This visit is not found</p>{" "}
              </div>
            ) : (
              <div className="flex-col">
                <BiCommentError className="text-3xl mx-auto my-3" />{" "}
                <p>{loaders.visit.loadingOneFailedMsg}</p>{" "}
              </div>
            )}
          </div>
        </div>
      ) : loaders.visit.loadingOne ? (
        <div className="bg-white mx-10 h-60 flex">
          <div className="spinner m-auto indigo-spinner">
            <div className="bounce1"></div>
            <div className="bounce2"></div>
            <div className="bounce3"></div>
          </div>
        </div>
      ) : (
        <div className="bg-white mx-10">
          <div className="flex flex-col md:flex-row p-10 pl-10 pb-0">
            <h2 className="font-semibold">
              <Link
                to="/services/events"
                className="hover:text-indigo-500 text-indigo-300"
              >
                Visits {">"}
              </Link>{" "}
              <span className="font-normal">{visitEvent.name}</span>
            </h2>
            <div className="md:m-auto mt-2 md:mr-0">
              <button
                className={
                  openUpperTab === 1
                    ? "p-2 mr-2 rounded text-white bg-indigo-500 hover:bg-indigo-400"
                    : "hidden"
                }
                onClick={() => {
                  openUpperTab === 1
                    ? benOverlayController()
                    : AddVisitController();
                }}
              >
                <FiEdit />
              </button>
              <button
                className={
                  openUpperTab === 1
                    ? "hidden"
                    : "p-2 mr-2 rounded text-white bg-indigo-500 hover:bg-indigo-400"
                }
                onClick={() => {
                  openUpperTab === 1
                    ? benOverlayController()
                    : editVisitController(visitEvent);
                }}
              >
                <FiEdit />
              </button>
              <button
                className={
                  openUpperTab === 1
                    ? "hidden"
                    : "p-2 mr-2 rounded text-red-500 border border-red-200 hover:bg-red-100"
                }
                onClick={() => {
                  handleDeleteEvent(selectedVisit);
                }}
              >
                <AiOutlineDelete />
              </button>
              <button
                className={
                  openUpperTab === 1
                    ? "p-2 mr-2 rounded text-gray-500 border border-gray-200 hover:bg-gray-100"
                    : "hidden"
                }
                onClick={() => {
                  openUpperTab === 1
                    ? filterOverlayController()
                    : VisitFilterOverlayController();
                }}
              >
                <FiFilter />
              </button>
              <button
                className={
                  openUpperTab === 1
                    ? "p-2 mr-2 rounded text-gray-500 border border-gray-200 hover:bg-gray-100"
                    : "hidden"
                }
                onClick={() => {
                  editVisitController(visitEvent);
                }}
              >
                <FcRefresh />
              </button>
              <button
                className={
                  openUpperTab === 1
                    ? "p-2 mr-2 rounded text-gray-500 border border-gray-200 hover:bg-gray-100"
                    : "hidden"
                }
              >
                <BsDownload />
              </button>
            </div>
          </div>
          {/* insurance tabs */}
          <div className="flex mt-2 flex-wrap">
            <div className="w-full">
              <ul
                className="flex mb-0 list-none flex-wrap  font-normal  flex-row w-full"
                role="tablist"
              >
                <li className="-mb-px  last:mr-0 ml-10">
                  <a
                    className={
                      "text-xs   px-5 py-1 pl-0   block leading-normal" +
                      (openUpperTab === 1
                        ? " text-white bg-indigo-500 rounded rounded-r-none border-b-2 border-" +
                          color +
                          "-500"
                        : " text-indigo-50 bg-indigo-300 rounded rounded-r-none border-b-2 border-indigo-300")
                    }
                    onClick={(e) => {
                      e.preventDefault();
                      setOpenUpperTab(1);
                    }}
                    data-toggle="tab"
                    href="#link1"
                    role="tablist"
                  >
                    <i className="fas fa-space-shuttle text-base mr-1"></i>{" "}
                    Visited beneficiaries
                  </a>
                </li>
                <li className="-mb-px  last:mr-0">
                  <a
                    className={
                      "text-xs   px-5 py-1 pl-0  block leading-normal " +
                      (openUpperTab === 2
                        ? " text-white bg-indigo-500 rounded rounded-l-none border-b-2 border-" +
                          color +
                          "-500"
                        : "text-indigo-50 bg-indigo-300 border-b-2 rounded rounded-l-none border-indigo-300")
                    }
                    onClick={(e) => {
                      e.preventDefault();
                      setOpenUpperTab(2);
                    }}
                    data-toggle="tab"
                    href="#link2"
                    role="tablist"
                  >
                    <i className="fas fa-cog text-base mr-1"></i> Information
                  </a>
                </li>
              </ul>
              <div className="relative flex flex-col min-w-0 break-words  w-full mb-2">
                <div>
                  <div className="tab-content tab-space">
                    <div
                      className={
                        openUpperTab === 1 ? "flex flex-col" : "hidden"
                      }
                      id="link1"
                    >
                      <div className="pb-5 px-0  flex flex-wrap  w-full">
                        {/* visited beneficiary table */}
                        <div className="w-full pr-10">
                          {(!loaders.benVisit.fetchingLoaders &&
                            visitedBens?.length < 1) |
                          loaders.benVisit.fetchFailedMessage ? (
                            <div
                              className={
                                !loaders.benVisit.fetchFailedMessage
                                  ? "bg-gray-100 fit-content  text-xs rounded text-center py-2 px-4 text-gray-500 font-semibold m-auto"
                                  : "bg-red-100 text-xs rounded fit-content text-center py-2 px-4 text-red-500 font-semibold m-auto"
                              }
                            >
                              <p className="m-auto">
                                {!loaders.benVisit.fetchFailedMessage
                                  ? "No visited beneficiary record"
                                  : loaders.benVisit.fetchFailedMessage}
                              </p>
                            </div>
                          ) : (
                            <Table
                              data={
                                loaders.benVisit.fetchingLoaders
                                  ? loadingAttendees
                                  : loadedAttendees
                              }
                              columns={columns}
                            />
                          )}{" "}
                        </div>
                      </div>
                    </div>
                    {/* Visits table */}
                    <div
                      className={
                        openUpperTab === 2 ? "flex flex-col" : "hidden"
                      }
                      id="link1"
                    >
                      <div className="pb-5 px-0 flex flex-wrap  w-full">
                        {/* Academics table */}
                        <div className="w-full flex flex-col my-3 ml-10 mr-10 border">
                          <div className="flex flex-row border-b p-5">
                            <div className="font-semibold w-2/12">
                              Event type
                            </div>
                            <div>{"Visit"}</div>
                          </div>
                          <div className="flex flex-row border-b p-5">
                            <div className="font-semibold w-2/12">
                              Event date
                            </div>
                            <div className="flex flex-col">
                              <div className="flex-row flex">
                                <p className="bg-indigo-100 w-2 h-2 font-normal text-indigo-500 m-auto ml-0 mr-2 rounded-full">
                                  {" "}
                                </p>{" "}
                                <span>
                                  {changeFromTimeStamp(visitEvent.startDate)}
                                </span>
                              </div>
                              <div className={"flex-row flex"}>
                                <p className="border border-indigo-200 w-2 h-2 font-normal text-indigo-500 m-auto ml-0 mr-2  rounded-full">
                                  {" "}
                                </p>{" "}
                                <span>
                                  {" "}
                                  {changeFromTimeStamp(visitEvent.endDate)}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* end.... */}
          {/*add insurance overlay  */}
          <div
            className={
              addBenOverlay || editBenOverlay ? "flex w-screen" : "hidden"
            }
          >
            <Overlay>
              <div className="bg-white m-auto  rounded">
                <div
                  className={
                    loaders.benVisit.message
                      ? "bg-red-100 text-xs rounded text-center py-2 text-red-500 font-semibold"
                      : "hidden"
                  }
                >
                  <p>{loaders.benVisit.message}</p>
                </div>
                <div className="p-10">
                  <div className="flex">
                    <h2 className="font-semibold  w-80">
                      {addBenOverlay
                        ? "Add visited beneficiary"
                        : "Change visited beneficiary info"}
                    </h2>
                    <div className="m-auto mr-0">
                      <button
                        className="flex flex-row p-1  bg-gray-300 hover:bg-gray-500 text-white text-sm rounded-full"
                        onClick={() => {
                          addBenOverlay
                            ? benOverlayController()
                            : editOverlayController({
                                id: "",
                                visitedBeneficiary: {
                                  id: "",
                                },
                                attendTime: "",
                              });
                        }}
                      >
                        <IoCloseOutline className="text-white" />{" "}
                      </button>
                    </div>
                  </div>{" "}
                  <form
                    className="flex flex-wrap"
                    onSubmit={handleAttendeeSubmit}
                  >
                    <div className="w-full">
                      <div className="flex flex-col pt-3">
                        {/*  field */}
                        <div className="py-2 w-full">
                          <label>Beneficiary Id</label>
                          <Select
                            options={beneficiriesOption}
                            value={beneficiriesOption.find(
                              (obj) => obj.value === visitedBen.beneficiaryId
                            )}
                            onChange={(e) =>
                              setVisitedBen({
                                ...visitedBen,
                                beneficiaryId: e.value,
                              })
                            }
                          />
                        </div>
                        {/*  field */}
                        <div className="py-2 w-full">
                          <label>Beneficiary Name </label>
                          <div className={style.field.parentDiv}>
                            <input
                              type="text"
                              className={style.field.input + "uppercase"}
                              value={
                                visitedBen.beneficiaryId
                                  ? selectedBeneficiary[0].name
                                  : ""
                              }
                              readOnly
                            />
                          </div>
                        </div>
                        {/*  field */}
                        <div className="py-2  w-full">
                          <div>
                            <label>Visited At</label>
                            <div className={style.field.parentDiv}>
                              <input
                                type="text"
                                className={style.field.input}
                                value={visitedBen.visitedAt}
                                onChange={(e) =>
                                  setVisitedBen({
                                    ...visitedBen,
                                    visitedAt: e.target.value,
                                  })
                                }
                              />
                            </div>
                          </div>
                        </div>
                        {/*  field */}
                        <div className="py-2  w-full">
                          <div>
                            <label>Visited on</label>
                            <div className={style.field.parentDiv}>
                              <input
                                type="date"
                                className={style.field.input}
                                value={visitedBen.visitedOn}
                                onChange={(e) =>
                                  setVisitedBen({
                                    ...visitedBen,
                                    visitedOn: e.target.value,
                                  })
                                }
                              />
                            </div>
                          </div>
                        </div>
                        {/*  field */}
                        <div className="py-2 w-full">
                          <label>Comment on visit </label>
                          <div className={style.field.parentDiv}>
                            <textarea
                              className={style.field.input}
                              value={visitedBen.comment}
                              onChange={(e) =>
                                setVisitedBen({
                                  ...visitedBen,
                                  comment: e.target.value,
                                })
                              }
                            ></textarea>
                          </div>
                        </div>
                        {/* save btn */}
                        <button
                          type="submit"
                          className={style.loginBtn}
                          disabled={loaders.benVisit.sendingLoader}
                        >
                          {!loaders.benVisit.sendingLoader ? (
                            <p className="m-auto">
                              {addBenOverlay ? "Save" : "Update"}
                            </p>
                          ) : (
                            <div className="spinner m-auto">
                              <div className="bounce1"></div>
                              <div className="bounce2"></div>
                              <div className="bounce3"></div>
                            </div>
                          )}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </Overlay>
          </div>
          {/*edit Visit overlay  */}
          <div className={addVisit || editVisit ? "flex w-screen" : "hidden"}>
            <Overlay>
              <div className="bg-white m-auto  rounded">
                <div
                  className={
                    loaders.visit.message
                      ? "bg-red-100 text-xs rounded text-center py-2 text-red-500 font-semibold"
                      : "hidden"
                  }
                >
                  <p>{loaders.visit.message}</p>
                </div>
                <div className="p-10">
                  <div className="flex">
                    <h2 className="font-semibold  w-80">
                      {"Change event info"}
                    </h2>
                    <div className="m-auto mr-0">
                      <button
                        className="flex flex-row p-1  bg-gray-300 hover:bg-gray-500 text-white text-sm rounded-full"
                        onClick={() => {
                          addVisit
                            ? AddVisitController()
                            : editVisitController({
                                id: "",
                              });
                        }}
                      >
                        <IoCloseOutline className="text-white" />{" "}
                      </button>
                    </div>
                  </div>{" "}
                  <div className="flex flex-wrap">
                    <div className="w-full">
                      <div className="flex flex-wrap">
                        <div className="w-full">
                          <form
                            className="relative flex flex-col min-w-0 break-words bg-white w-full mb-2"
                            onSubmit={handleVisitSubmit}
                          >
                            <div>
                              <div className="flex flex-col pt-3">
                                {/*  field */}
                                <div className="py-2 w-full">
                                  <label>Name </label>
                                  <div className={style.field.parentDiv}>
                                    <input
                                      type="text"
                                      className={style.field.input}
                                      value={event.name}
                                      onChange={(e) =>
                                        setEvent({
                                          ...event,
                                          name: e.target.value,
                                        })
                                      }
                                    />
                                  </div>
                                </div>

                                <div className="py-2 w-full">
                                  <label>Start date </label>
                                  <div className={style.field.parentDiv}>
                                    <input
                                      type="date"
                                      className={style.field.input}
                                      value={event.startDate}
                                      onChange={(e) =>
                                        setEvent({
                                          ...event,
                                          startDate: e.target.value,
                                        })
                                      }
                                    />
                                  </div>
                                </div>

                                <div className={"py-2 w-full"}>
                                  <label>End date </label>
                                  <div className={style.field.parentDiv}>
                                    <input
                                      type="date"
                                      className={style.field.input}
                                      value={event.endDate}
                                      onChange={(e) =>
                                        setEvent({
                                          ...event,
                                          endDate: e.target.value,
                                        })
                                      }
                                    />
                                  </div>
                                </div>

                                {/* save btn */}
                                <button
                                  type="submit"
                                  className={style.loginBtn}
                                  disabled={loaders.visit.sendingLoader}
                                >
                                  {!loaders.visit.sendingLoader ? (
                                    <p className="m-auto">{"Save"}</p>
                                  ) : (
                                    <div className="spinner m-auto">
                                      <div className="bounce1"></div>
                                      <div className="bounce2"></div>
                                      <div className="bounce3"></div>
                                    </div>
                                  )}{" "}
                                </button>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Overlay>
          </div>
          {/* filter insurance  overlay */}
          <div className={filterBenOverlay ? "flex w-screen" : "hidden"}>
            <Overlay>
              <div className="p-10 bg-white m-auto  rounded">
                <div className="flex">
                  <h2 className="font-semibold">
                    {"Kuyungurura ubwishingizi"}
                  </h2>
                  <div className="m-auto mr-0">
                    <button
                      className="flex flex-row p-1  bg-gray-300 hover:bg-gray-500 text-white text-sm rounded-full"
                      onClick={() => {
                        filterOverlayController();
                      }}
                    >
                      <IoCloseOutline className="text-white" />{" "}
                    </button>
                  </div>
                </div>{" "}
                <div className="flex flex-col pt-3">
                  {/*  field */}
                  <div className="py-2 w-full">
                    <label>Nomero</label>
                    <div className="flex w-full">
                      <Select options={beneficiaries} className="w-1/2 mr-2" />

                      <Select options={beneficiaries} className="w-1/2" />
                    </div>{" "}
                  </div>
                  {/*  field */}
                  <div className="py-2  w-full">
                    <label>Uwasuzumwe </label>
                    <Select options={beneficiaryStatus} isMulti />
                  </div>

                  {/*  field */}
                  <div className="py-2 w-full">
                    <label>Igihe </label>
                    <div className="flex w-full">
                      <div className={style.field.parentDiv + " mr-2 w-1/2"}>
                        <input
                          type="date"
                          className={style.field.input}
                          placeholder="Guhera"
                        />
                      </div>
                      <div className={style.field.parentDiv + " w-1/2"}>
                        <input
                          type="date"
                          className={style.field.input}
                          placeholder="Kugeza"
                        />
                      </div>
                    </div>
                  </div>

                  {/* save btn */}
                  <button type="submit" className={style.loginBtn}>
                    <p className="m-auto">{"Kuyungurura"}</p>
                  </button>
                </div>
              </div>
            </Overlay>
          </div>
          {/* filter Visits  overlay */}
          <div className={filterVisitOverlay ? "flex w-screen" : "hidden"}>
            <Overlay>
              <div className="p-10 bg-white m-auto  rounded">
                <div className="flex">
                  <h2 className="font-semibold">
                    {"Kuyungurura inkunga k`ubwishingizi"}
                  </h2>
                  <div className="m-auto mr-0">
                    <button
                      className="flex flex-row p-1  bg-gray-300 hover:bg-gray-500 text-white text-sm rounded-full"
                      onClick={() => {
                        VisitFilterOverlayController();
                      }}
                    >
                      <IoCloseOutline className="text-white" />{" "}
                    </button>
                  </div>
                </div>{" "}
                <div className="flex flex-col pt-3">
                  {/*  field */}
                  <div className="py-2 w-full">
                    <label>Nomero</label>
                    <div className="flex w-full">
                      <Select options={beneficiaries} className="w-1/2 mr-2" />

                      <Select options={beneficiaries} className="w-1/2" />
                    </div>{" "}
                  </div>
                  {/*  field */}
                  <div className="py-2  w-full">
                    <label>Uko ahagaze </label>
                    <Select options={beneficiaryStatus} isMulti />
                  </div>

                  {/*  field */}
                  <div className="py-2 w-full">
                    <label>Igihe </label>
                    <div className="flex w-full">
                      <div className={style.field.parentDiv + " mr-2 w-1/2"}>
                        <input
                          type="date"
                          className={style.field.input}
                          placeholder="Guhera"
                        />
                      </div>
                      <div className={style.field.parentDiv + " w-1/2"}>
                        <input
                          type="date"
                          className={style.field.input}
                          placeholder="Kugeza"
                        />
                      </div>
                    </div>
                  </div>
                  {/*  field */}
                  <div className="py-2 w-full">
                    <label>Ayishyuwe </label>
                    <div className="flex w-full">
                      <div className={style.field.parentDiv + " mr-2 w-1/2"}>
                        <input
                          type="text"
                          className={style.field.input}
                          placeholder="Akenewe"
                        />
                      </div>
                      <div className={style.field.parentDiv + " w-1/2"}>
                        <input
                          type="text"
                          className={style.field.input}
                          placeholder="Inkunga"
                        />
                      </div>
                    </div>
                  </div>
                  {/* save btn */}
                  <button type="submit" className={style.loginBtn}>
                    <p className="m-auto">{"Kuyungurura"}</p>
                  </button>
                </div>
              </div>
            </Overlay>
          </div>
        </div>
      )}
    </DashLayout>
  );
}

export default ViewVisit;
